import React, { Component } from 'react'
import ManualAssignUi from './ManualAssign.container'
import AssignByState from './AssignByState.container'
import AssignByStatus from '../Settings/assignmentRules/mainTabs'
import AssignByStatusNew from '../Settings/assignmentRulesNew/mainTabs'
import AssignForCollectionUi from './AssIgnForCollection.container'
import AssignViaCSV from './AssignViaCsv.container'
import { ROLE } from '../../../../utils/Constant'
import BackLogo from '../../../../images/rewampimages/Chevron.png'
import { EmailcheckFn, SuperUsercheck } from '../../../../utils/CustomEmailCheck'

class BulkAssign extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageViewState: ''
        }
    }


    render() {
        const { admin, allStatus, pageViewHandler } = this.props;
         const customWidth = {
            width: EmailcheckFn(admin.emailId,SuperUsercheck) ?  'calc(100%/4)' : 'calc(100%/3)'
        }
        return (
             <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-4">
                        <div className='' style={{ marginTop: '10px', marginBottom: window.innerWidth > 1800 ? '100px' : '10px', display: 'inline-flex', alignItems: 'center' }} onClick={(e) => pageViewHandler(e, 'landingPage')}>
                            <img src={BackLogo} alt="" width={'35%'} style={{ marginRight: '10px', cursor: 'pointer' }} />
                            <h5 style={{ cursor: 'pointer' }}>Back</h5>
                        </div>
                    </div>
                    <div className="col-sm-4 text-center">
                        <h3><b>Lead Management</b></h3>
                    </div>
                </div>
                <div className="row" style={{ marginTop: '15px' }}>
                    <div className="col-xs-12">
                        {/* <div className="btn-group">
                            {admin.rolelist != undefined ? admin.rolelist.indexOf(ROLE.Manual_Lead_Assignment) >= 0 ? <button className={this.state.pageViewState == 'manualAssign' ? 'btn-active' : 'btn'} onClick={e => this.buttonActionHandler("manualAssign")}>Manual Assign</button> : "" : ""}
                            {admin.rolelist != undefined ? admin.rolelist.indexOf(ROLE.LM_Assignment_Rule) >= 0 ? <button className={this.state.pageViewState == 'assignByStatus' ? 'btn-active' : 'btn'} onClick={e => this.buttonActionHandler("assignByStatus")}>Assignment Rule</button> : "" : ""}
                            {admin.rolelist != undefined ? admin.rolelist.indexOf(ROLE.Manual_Lead_Assignment) >= 0 ? <button className={this.state.pageViewState == 'assignViaCsv' ? 'btn-active' : 'btn'} onClick={e => this.buttonActionHandler("assignViaCsv")}>Assignment Via CSV</button> : "" : ""}
                        </div> */}
                        <div className="btn-grp-own-lead-manage-new" role="group" aria-label="onboard-btn" style={{ padding: '10px' }}>
                            {admin.rolelist != undefined ? admin.rolelist.indexOf(ROLE.Manual_Lead_Assignment) >= 0 ? <button className={this.state.pageViewState == 'manualAssign' ? 'btn-active' : 'btn'} onClick={e => this.buttonActionHandler("manualAssign")} style={customWidth}>Manual Assign</button> : "" : ""}
                            {admin.rolelist != undefined ? admin.rolelist.indexOf(ROLE.LM_Assignment_Rule) >= 0 ? <button className={this.state.pageViewState == 'assignByStatus' ? 'btn-active' : 'btn'} onClick={e => this.buttonActionHandler("assignByStatus")} style={customWidth}>Assignment Rule</button> : "" : ""}
                            {admin.rolelist != undefined ? admin.rolelist.indexOf(ROLE.LM_Assignment_Rule) >= 0 ? <button className={this.state.pageViewState == 'assignByStatusNew' ? 'btn-active' : 'btn'} onClick={e => this.buttonActionHandler("assignByStatusNew")} style={customWidth}>Assignment Rule</button> : "" : ""}
                            {admin.rolelist != undefined ? admin.rolelist.indexOf(ROLE.Manual_Lead_Assignment) >= 0 ? <button className={this.state.pageViewState == 'assignViaCsv' ? 'btn-active' : 'btn'} onClick={e => this.buttonActionHandler("assignViaCsv")} style={customWidth}>Assignment Via CSV</button> : "" : ""}

                        </div>
                    </div>
                </div>
                {this.state.pageViewState == 'manualAssign' ?
                    <ManualAssignUi
                        admin={admin}
                        allStatus={allStatus} />
                    : this.state.pageViewState == 'assignForCollection' ?
                        <AssignForCollectionUi
                            admin={admin}
                            allStatus={allStatus} />
                        :
                        this.state.pageViewState == 'assignByState' ?
                            <AssignByState
                                admin={admin} />
                            : this.state.pageViewState == 'assignByStatus' ?
                                <AssignByStatus
                                    admin={admin} />

                                : this.state.pageViewState == 'assignByStatusNew' ?

                                    <AssignByStatusNew
                                        admin={admin} />
                                    : this.state.pageViewState == 'assignViaCsv' ?
                                        <AssignViaCSV
                                            admin={admin} />
                                        : null}
            </div>
        )
    }

    buttonActionHandler(type) {
        this.setState({ pageViewState: type })
    }

}

export default BulkAssign;